<template>
  <div class="wrapper" style="margin: 20px 20px">
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column fixed  :label="$t('crs.pushMsg.env')">
        <template slot-scope="scope">
            <div>{{scope.row.env==2? $t('crs.pushMsg.prd'):$t('crs.pushMsg.dev')}}</div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" :label="$t('common.handle')">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">{{$t('crs.pushMsg.check')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  //table封装组件
  import URL from '@/views/crs/util/url'
  import Qs from 'qs'
  let env = "";
  export default {
    name: 'env',
    mounted(){
        this.getEnv();
    },
    methods: {
        handleClick(row){
            this.setEnv(row.env == 2?1:2)
      },
      getEnv(){
          this.$axios.post(URL.pushMsgLog.getEnv).then(res => {
              if(res.code == 0) {
                  this.tableData = [{env: res.result}];
              }

          })
      },
      setEnv(env){
          this.$axios.post(URL.pushMsgLog.setEnv,Qs.stringify({env:env})).then(res => {
              if(res.code == 0) {
                  this.getEnv();
              };
          })
      }
    },
    data () {
      return {
          tableData: [{env: env}]
      }
    }
  }
</script>
